import Asset from 'backbone/platform/models/assets/asset.js'
import MediaLibraryAsset from 'backbone/platform/models/assets/media_library_asset.js'
import MultiAssetPickerView from 'backbone/platform/views/assets/multi_asset_picker_view.js'
import RequirementAssettingFormView from 'backbone/platform/views/assets/requirement_assetting_form_view.js'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'

export default class RequirementAssettingAttacherView extends Backbone.View
  events:
    "click .js-delete-assetting" : "deleteAsset"
    "click .js-attach"           : "showAssetPicker"

  initialize: (options) ->
    @options = options
    @$briefAssets = @$el.find(".file-list-container")
    @$spinnerProcessing = @$el.find(".js-processing")
    @mediaLibraryAccess = options.mediaLibraryAccess
    @brandProfileId = options.brandProfileId
    @assetable_type = options.assetable_type
    @dispatcher = BackboneDispatcher.get_instance()
    @dispatcher.bind("assetProcessingComplete", @assetProcessingComplete)
    @dispatcher.bind("s3UploadStart", @s3UploadStart)
    @publication = options.publication
    @supportedImageFileExtensions = options.supportedImageFileExtensions
    @setupS3Uploader()
    if options.assets?
      assets = _.map options.assets, (asset) ->
        new Asset(asset)
      @attachAssets(assets)

  setupS3Uploader: ->
    uploaderOptions =
      assetableType: @assetable_type
      assetType: "requirement"
      externalProcessing: false

    @dispatcher.trigger("setParentResourceOptions", uploaderOptions)

  showAssetPicker: =>
    @setupS3Uploader()

    if @assetable_type is "Pitch"
      page = "pitch-brief"
      modalHeaderTitle = "Attach additional material"
      modalAttachText =
        @supportedImageFileExtensions
          .toString()
          .replace(/,/g , ", ")
          .toUpperCase()
    else if @assetable_type is "Story"
      modalHeaderTitle = "Attach requirement assets"
      modalAttachText = "Up to 5GB per file"

    @assetPicker = new MultiAssetPickerView(
      el: $("#asset-picker-modal .asset-content")
      mediaLibraryAccess: @mediaLibraryAccess
      brandProfileId: @brandProfileId
      assetsPicked: @attachAssets
      page: page if page
      modalHeaderTitle: modalHeaderTitle
      modalAttachText: modalAttachText
    )

  s3UploadStart: (upload) =>
    return unless upload.assetType == "requirement"
    @$spinnerProcessing.removeClass("hidden")
    contently.ui.closeModal()

  emptySelected: ->
    @$briefAssets.empty()

  assetProcessingComplete: (payload) =>
    return unless payload.upload.assetType == "requirement"
    @$spinnerProcessing.addClass("hidden")
    asset = new MediaLibraryAsset
      asset_id: payload.asset.id
      url: payload.asset.url
      title: payload.asset.name
      filesize: payload.asset.data_file_size
      height: payload.asset.height
      width: payload.asset.width
    @attachAssets([asset])

  attachAssets: (assets) =>
    for asset in assets
      mediaLibraryAsset = new RequirementAssettingFormView
        asset: asset,
        assetable_type: @assetable_type
        publication: @publication
        supportedImageFileExtensions: @supportedImageFileExtensions

      @$briefAssets.append(mediaLibraryAsset.render().el)

  deleteAsset: (event) ->
    $(event.currentTarget).closest('.list-item-wrapper').fadeOut(-> $(this).remove())



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/assets/requirement_assetting_attacher_view.js.coffee